module.exports = __webpack_public_path__ + "img/bwg1.23ccd16b.png";